<template>
    <div  class="list-main">
      <div class="trans-header">
        <div class="trans-header-select">
          <div class="check-tab-default" :class="activeTabClassAll" data-track-text="全部文档" aria-label="全部文档" @click="handleClickH5('all')" style="flex: 0.5;">全部
          </div>
          <div class="check-tab-default" :class="activeTabClassFirst" data-track-text="机器翻译文档" aria-label="机器翻译文档" @click="handleClickH5('first')">机器翻译</div>
          <div class="check-tab-default" :class="activeTabClassFour" data-track-text="专业翻译文档" aria-label="专业翻译文档" @click="handleClickH5('four')">专业翻译</div>
          <div class="check-tab-default" :class="activeTabClassThree" data-track-text="英语母语润色文档" aria-label="英语母语润色文档" @click="handleClickH5('three')" style="flex: 1.5;">
            英语母语润色翻译
          </div>
          <div class="check-tab-default" :class="activeTabClassSecond" data-track-text="转换文档" aria-label="转换文档" @click="handleClickH5('second')">转换文档</div>
        </div>
      </div>
      <div class="trans-list-context">
        <div class="list-context">
          <div v-show="activeName==='all'" class="filelist-domain">
            <div class="list-context-search">
              <div class="list-context-search-input">
                <el-input
                    placeholder="文件名"
                    suffix-icon="el-icon-search"
                    v-model="fileName">
                </el-input>
              </div>
              <div class="list-context-search-select">
                <el-select popper-class="fileStatus" v-model="statusList" placeholder="状态">
                  <el-option
                      v-for="item in fileStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <ul class="infinite-list" v-infinite-scroll="loadH5" infinite-scroll-disabled="disabled" style="overflow:auto">
              <li v-for="item in allTableData" class="infinite-list-item">
                <el-popover
                    :visible-arrow="false"
                    popper-class="popper-class"
                    placement="right"
                    trigger="click">
                  <div
                      style="align-items: center;justify-content: center;display:flex;width: 375px;margin-top: 23px;height: 120px;background: #063F95;">
                    <div v-show="(item.uploadType===3||item.uploadType===2)&&item.status!=='394' && item.status==='431'"
                         style="display:flex;align-items:center;justify-content:center;flex: 1">
                      <img
                          @click="(item.uploadType===3||item.uploadType===2)&&item.status!=='394' && item.status==='431'?toPathH5(item.id):'javascript:void(0)'"
                          :style="(item.uploadType===3||item.uploadType===2)&&item.status!=='394' && item.status==='431'?'':'opacity: 0.5;'"
                          data-track-text="继续支付" aria-label="继续支付" src="../../assets/H5/list-time.png" width="48" alt=""/>
                    </div>
                    <div v-show="item.uploadType===0||item.uploadType===2||item.uploadType===3"
                         style="display:flex;align-items:center;justify-content:center;flex: 1">
                      <img
                          @click="(item.uploadType===0||item.uploadType===2||item.uploadType===3)&&(item.status==='已翻译' || item.status==='已下载' || item.status==='396' || item.status==='502')?readingFileH5(item.id):'javascript:void(0)'"
                          :style="(item.uploadType===0||item.uploadType===2||item.uploadType===3)&&(item.status==='已翻译' || item.status==='已下载' || item.status==='396' || item.status==='502')?'':'opacity: 0.5;'"
                          data-track-text="阅读文档" aria-label="阅读文档" src="../../assets/H5/list-read.png" width="54" alt=""/>
                    </div>
                    <div style="display:flex;align-items:center;justify-content:center;flex: 1">
                      <img
                          @click="item.status==='已翻译' || item.status==='已下载' || item.status==='已转换'||item.status === '396'||item.status === '502'?item.uploadType===1?downloadConvertFileH5(item):downloadFileH5(item):'javascript:void(0)'"
                          :style="item.status==='已翻译' || item.status==='已下载' || item.status==='已转换'||item.status === '396'||item.status === '502'?'':'opacity: 0.5;'"
                          data-track-text="下载文档" aria-label="下载文档" src="../../assets/H5/list-del.png" width="40" alt=""/>
                    </div>
                    <div style="display:flex;align-items:center;justify-content:center;flex: 1">
                      <img
                          @click="item.status==='431'||item.status==='待支付' || item.status==='已翻译' || item.status==='已下载'||item.status === '已转换'||item.status === '396'||item.status === '502'?deleteFileH5(item.id):'javascript:void(0)'"
                          :style="item.status==='431'||item.status==='待支付' || item.status==='已翻译' || item.status==='已下载'||item.status === '已转换'||item.status === '396'||item.status === '502'?'':'opacity: 0.5;'"
                          data-track-text="删除文档" aria-label="删除文档" src="../../assets/H5/liet-down.png" width="48" alt=""/>
                    </div>
                  </div>
                  <div slot="reference">
                    <div style="margin-top: 20px;" class="item">
                      <div
                          :class="item.status==='已翻译'||item.status==='已转换'||item.status==='396'?'item-status':'item-other'">
                        {{
                          item.status === '394' ? "待支付" :
                              item.status === '431' ? "等待客服沟通......" :
                                  item.status === '395' ? "等待译员处理" :
                                      item.status === '396' ? "人工翻译已完成" :
                                          item.status === '502' ? "已下载" :
                                              item.status === '501' ? "已删除" :
                                                  item.status === '500' ? "已过期" :
                                                      item.status === '448' ? "任务终止,退款中" : item.status
                        }}
                      </div>
                      <div class="item-name">{{ item.name }}</div>
                    </div>
                    <div class="item">
                      <div class="item-language">翻译语言：{{ item.language }}</div>
                      <div class="item-comment">翻译需求：{{ item.comment }}</div>
                      <div class="item-pageNum">页数：{{ item.pageNum }}</div>
                    </div>
                  </div>
                </el-popover>
              </li>
            </ul>
            <p v-if="loading">加载中...</p>
            <p v-if="noMore" style="font-size: 24px;font-family: Source Han Sans CN;font-weight: 400;color: #333333;">
              没有更多了</p>
          </div>
          <div v-show="activeName==='first'" class="filelist-domain">
            <div class="list-context-search">
              <div class="list-context-search-input">
                <el-input
                    placeholder="文件名"
                    suffix-icon="el-icon-search"
                    v-model="fileName">
                </el-input>
              </div>
              <div class="list-context-search-select">
                <el-select popper-class="fileStatus" v-model="statusList" placeholder="状态">
                  <el-option
                      v-for="item in fileStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <ul class="infinite-list" v-infinite-scroll="loadFirstH5" infinite-scroll-disabled="disabled"
                style="overflow:auto">
              <li v-for="item in tableData" class="infinite-list-item">
                <el-popover
                    :visible-arrow="false"
                    popper-class="popper-class"
                    placement="right"
                    trigger="click">
                  <div
                      style="align-items: center;justify-content: center;display:flex;width: 375px;margin-top: 23px;height: 120px;background: #063F95;">
                    <div v-show="(item.uploadType===3||item.uploadType===2)&&item.status!=='394' && item.status==='431'"
                         style="display:flex;align-items:center;justify-content:center;flex: 1">
                      <img
                          @click="(item.uploadType===3||item.uploadType===2)&&item.status!=='394' && item.status==='431'?toPathH5(item.id):'javascript:void(0)'"
                          :style="(item.uploadType===3||item.uploadType===2)&&item.status!=='394' && item.status==='431'?'':'opacity: 0.5;'"
                          data-track-text="继续支付" aria-label="继续支付" src="../../assets/H5/list-time.png" width="48" alt=""/>
                    </div>
                    <div style="display:flex;align-items:center;justify-content:center;flex: 1">
                      <img
                          @click="item.uploadType===0&&(item.status==='已翻译' || item.status==='已下载')?readingFileH5(item.id):'javascript:void(0)'"
                          :style="item.uploadType===0&&(item.status==='已翻译' || item.status==='已下载')?'':'opacity: 0.5;'"
                          data-track-text="阅读文档" aria-label="阅读文档" src="../../assets/H5/list-read.png" width="54" alt=""/>
                    </div>
                    <div style="display:flex;align-items:center;justify-content:center;flex: 1">
                      <img
                          @click="item.status==='已翻译' || item.status==='已下载' || item.status==='已转换'||item.status === '396'||item.status === '502'?downloadFileH5(item):'javascript:void(0)'"
                          :style="item.status==='已翻译' || item.status==='已下载' || item.status==='已转换'||item.status === '396'||item.status === '502'?'':'opacity: 0.5;'"
                          data-track-text="下载文档" aria-label="下载文档" src="../../assets/H5/list-del.png" width="40" alt=""/>
                    </div>
                    <div style="display:flex;align-items:center;justify-content:center;flex: 1">
                      <img
                          @click="(item.status!=='394' && item.status==='431')||item.status==='待支付' || item.status==='已翻译' || item.status==='已下载'||item.status === '已转换'||item.status === '396'||item.status === '502'?deleteFileH5(item.id):'javascript:void(0)'"
                          :style="(item.status!=='394' && item.status==='431')||item.status==='待支付' || item.status==='已翻译' || item.status==='已下载'||item.status === '已转换'||item.status === '396'||item.status === '502'?'':'opacity: 0.5;'"
                          data-track-text="删除文档" aria-label="删除文档" src="../../assets/H5/liet-down.png" width="48" alt=""/>
                    </div>
                  </div>
                  <div slot="reference">
                    <div style="margin-top: 20px;" class="item">
                      <div
                          :class="item.status==='已翻译'||item.status==='已转换'||item.status==='396'?'item-status':'item-other'">
                        {{
                          item.status === '394' ? "待支付" :
                              item.status === '431' ? "等待客服沟通......" :
                                  item.status === '395' ? "等待译员处理" :
                                      item.status === '396' ? "人工翻译已完成" :
                                          item.status === '502' ? "已下载" :
                                              item.status === '501' ? "已删除" :
                                                  item.status === '500' ? "已过期" :
                                                      item.status === '448' ? "任务终止,退款中" : item.status
                        }}
                      </div>
                      <div class="item-name">{{ item.name }}</div>
                    </div>
                    <div class="item">
                      <div class="item-language">翻译语言：{{ item.language }}</div>
                      <div class="item-pageNum">页数：{{ item.pageNum }}</div>
                    </div>
                  </div>
                </el-popover>
              </li>
            </ul>
            <p v-if="loadingFirst">加载中...</p>
            <p v-if="noMoreFirst"
               style="font-size: 24px;font-family: Source Han Sans CN;font-weight: 400;color: #333333;">
              没有更多了</p>
          </div>
          <div v-show="activeName==='second'" class="filelist-domain">
            <div class="list-context-search">
              <div class="list-context-search-input">
                <el-input
                    placeholder="文件名"
                    suffix-icon="el-icon-search"
                    v-model="fileName">
                </el-input>
              </div>
              <div class="list-context-search-select">
                <el-select popper-class="fileStatus" v-model="statusList" placeholder="状态">
                  <el-option
                      v-for="item in fileStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <ul class="infinite-list" v-infinite-scroll="loadSecondH5" infinite-scroll-disabled="disabled"
                style="overflow:auto">
              <li v-for="item in convertTableData" class="infinite-list-item">
                <el-popover
                    :visible-arrow="false"
                    popper-class="popper-class"
                    placement="right"
                    trigger="click">
                  <div
                      style="align-items: center;justify-content: center;display:flex;width: 375px;margin-top: 23px;height: 120px;background: #063F95;">
                    <div v-show="(item.uploadType===3||item.uploadType===2)&&item.status!=='394' && item.status==='431'"
                         style="display:flex;align-items:center;justify-content:center;flex: 1">
                      <img
                          @click="(item.uploadType===3||item.uploadType===2)&&item.status!=='394' && item.status==='431'?toPathH5(item.id):'javascript:void(0)'"
                          :style="(item.uploadType===3||item.uploadType===2)&&item.status!=='394' && item.status==='431'?'':'opacity: 0.5;'"
                          data-track-text="继续支付" aria-label="继续支付" src="../../assets/H5/list-time.png" width="48" alt=""/>
                    </div>
                    <div v-show="item.uploadType===0&&(item.status==='已翻译' || item.status==='已下载')"
                         style="display:flex;align-items:center;justify-content:center;flex: 1">
                      <img
                          @click="item.uploadType===0&&(item.status==='已翻译' || item.status==='已下载')?readingFileH5(item.id):'javascript:void(0)'"
                          :style="item.uploadType===0&&(item.status==='已翻译' || item.status==='已下载')?'':'opacity: 0.5;'"
                          data-track-text="阅读文档" aria-label="阅读文档" src="../../assets/H5/list-read.png" width="54" alt=""/>
                    </div>
                    <div style="display:flex;align-items:center;justify-content:center;flex: 1">
                      <img
                          @click="item.status==='已翻译' || item.status==='已下载' || item.status==='已转换'||item.status === '396'||item.status === '502'?downloadConvertFileH5(item):'javascript:void(0)'"
                          :style="item.status==='已翻译' || item.status==='已下载' || item.status==='已转换'||item.status === '396'||item.status === '502'?'':'opacity: 0.5;'"
                          data-track-text="下载文档" aria-label="下载文档" src="../../assets/H5/list-del.png" width="40" alt=""/>
                    </div>
                    <div style="display:flex;align-items:center;justify-content:center;flex: 1">
                      <img
                          @click="(item.status!=='394' && item.status==='431')||item.status==='待支付' || item.status==='已翻译' || item.status==='已下载'||item.status === '已转换'||item.status === '396'||item.status === '502'?deleteFileH5(item.id):'javascript:void(0)'"
                          :style="(item.status!=='394' && item.status==='431')||item.status==='待支付' || item.status==='已翻译' || item.status==='已下载'||item.status === '已转换'||item.status === '396'||item.status === '502'?'':'opacity: 0.5;'"
                          data-track-text="删除文档" aria-label="删除文档" src="../../assets/H5/liet-down.png" width="48" alt=""/>
                    </div>
                  </div>
                  <div slot="reference">
                    <div style="margin-top: 20px;" class="item">
                      <div
                          :class="item.status==='已翻译'||item.status==='已转换'||item.status==='396'?'item-status':'item-other'">
                        {{
                          item.status === '394' ? "待支付" :
                              item.status === '431' ? "等待客服沟通......" :
                                  item.status === '395' ? "等待译员处理" :
                                      item.status === '396' ? "人工翻译已完成" :
                                          item.status === '502' ? "已下载" :
                                              item.status === '501' ? "已删除" :
                                                  item.status === '500' ? "已过期" :
                                                      item.status === '448' ? "任务终止,退款中" : item.status
                        }}
                      </div>
                      <div class="item-name">{{ item.name }}</div>
                    </div>
                    <div class="item">
                      <div class="item-language">翻译语言：{{ item.language }}</div>
                      <div class="item-pageNum">页数：{{ item.pageNum }}</div>
                    </div>
                  </div>
                </el-popover>
              </li>
            </ul>
            <p v-if="loadingSecond">加载中...</p>
            <p v-if="noMoreSecond"
               style="font-size: 24px;font-family: Source Han Sans CN;font-weight: 400;color: #333333;">
              没有更多了</p>

          </div>
          <div v-show="activeName==='three'" class="filelist-domain">
            <div class="list-context-search">
              <div class="list-context-search-input">
                <el-input
                    placeholder="文件名"
                    suffix-icon="el-icon-search"
                    v-model="fileName">
                </el-input>
              </div>
              <div class="list-context-search-select">
                <el-select popper-class="fileStatus" v-model="statusList" placeholder="状态">
                  <el-option
                      v-for="item in fileStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <ul class="infinite-list" v-infinite-scroll="loadThreeH5" infinite-scroll-disabled="disabled"
                style="overflow:auto">
              <li v-for="item in polishTableData" class="infinite-list-item">
                <el-popover
                    :visible-arrow="false"
                    popper-class="popper-class"
                    placement="right"
                    trigger="click">
                  <div
                      style="align-items: center;justify-content: center;display:flex;width: 375px;margin-top: 23px;height: 120px;background: #063F95;">
                    <div v-show="item.status!=='394' && item.status==='431'"
                         style="display:flex;align-items:center;justify-content:center;flex: 1">
                      <img
                          @click="item.status!=='394' && item.status==='431'?toPathH5(item.id):'javascript:void(0)'"
                          :style="item.status!=='394' && item.status==='431'?'':'opacity: 0.5;'"
                          data-track-text="继续支付" aria-label="继续支付" src="../../assets/H5/list-time.png" width="48" alt=""/>
                    </div>
                    <div style="display:flex;align-items:center;justify-content:center;flex: 1">
                      <img
                          @click="(item.status==='已翻译' || item.status==='已下载' || item.status==='396' || item.status==='502')?readingFileH5(item.id):'javascript:void(0)'"
                          :style="(item.status==='已翻译' || item.status==='已下载' || item.status==='396' || item.status==='502')?'':'opacity: 0.5;'"
                          data-track-text="阅读文档" aria-label="阅读文档" src="../../assets/H5/list-read.png" width="54" alt=""/>
                    </div>
                    <div style="display:flex;align-items:center;justify-content:center;flex: 1">
                      <img
                          @click="item.status==='已翻译' || item.status==='已下载' || item.status==='已转换'||item.status === '396'||item.status === '502'?item.uploadType===1?downloadConvertFileH5(item):downloadFileH5(item):'javascript:void(0)'"
                          :style="item.status==='已翻译' || item.status==='已下载' || item.status==='已转换'||item.status === '396'||item.status === '502'?'':'opacity: 0.5;'"
                          data-track-text="下载文档" aria-label="下载文档" src="../../assets/H5/list-del.png" width="40" alt=""/>
                    </div>
                    <div style="display:flex;align-items:center;justify-content:center;flex: 1">
                      <img
                          @click="(item.status==='431')||item.status==='待支付' || item.status==='已翻译' || item.status==='已下载'||item.status === '已转换'||item.status === '394'||item.status === '396'||item.status === '502'?deleteFileH5(item.id):'javascript:void(0)'"
                          :style="(item.status==='431')||item.status==='待支付' || item.status==='已翻译' || item.status==='已下载'||item.status === '已转换'||item.status === '394'||item.status === '396'||item.status === '502'?'':'opacity: 0.5;'"
                          data-track-text="删除文档" aria-label="删除文档" src="../../assets/H5/liet-down.png" width="48" alt=""/>
                    </div>
                  </div>
                  <div slot="reference">
                    <div style="margin-top: 20px;" class="item">
                      <div
                          :class="item.status==='已翻译'||item.status==='已转换'||item.status==='396'?'item-status':'item-other'">
                        {{
                          item.status === '394' ? "待支付" :
                              item.status === '431' ? "等待客服沟通......" :
                                  item.status === '395' ? "等待译员处理" :
                                      item.status === '396' ? "人工翻译已完成" :
                                          item.status === '502' ? "已下载" :
                                              item.status === '501' ? "已删除" :
                                                  item.status === '500' ? "已过期" :
                                                      item.status === '448' ? "任务终止,退款中" : item.status
                        }}
                      </div>
                      <div class="item-name">{{ item.name }}</div>
                    </div>
                    <div class="item">
                      <div class="item-language">翻译语言：{{ item.language }}</div>
                      <div class="item-comment" style="flex: 3;text-overflow: ellipsis;white-space: nowrap">
                        翻译需求：{{ item.comment }}
                      </div>
                    </div>
                  </div>
                </el-popover>
              </li>
            </ul>
            <p v-if="loadingThree">加载中...</p>
            <p v-if="noMoreThree"
               style="font-size: 24px;font-family: Source Han Sans CN;font-weight: 400;color: #333333;">
              没有更多了</p>
          </div>
          <div v-show="activeName==='four'" class="filelist-domain">
            <div class="list-context-search">
              <div class="list-context-search-input">
                <el-input
                    placeholder="文件名"
                    suffix-icon="el-icon-search"
                    v-model="fileName">
                </el-input>
              </div>
              <div class="list-context-search-select">
                <el-select popper-class="fileStatus" v-model="statusList" placeholder="状态">
                  <el-option
                      v-for="item in fileStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <ul class="infinite-list" v-infinite-scroll="loadFourH5" infinite-scroll-disabled="disabled"
                style="overflow:auto">
              <li v-for="item in docTableData" class="infinite-list-item">
                <el-popover
                    :visible-arrow="false"
                    popper-class="popper-class"
                    placement="right"
                    trigger="click">
                  <div
                      style="align-items: center;justify-content: center;display:flex;width: 375px;margin-top: 23px;height: 120px;background: #063F95;">
                    <div v-show="item.status==='431'"
                         style="display:flex;align-items:center;justify-content:center;flex: 1">
                      <img
                          @click="item.status==='431'?toPathH5(item.id):'javascript:void(0)'"
                          :style="item.status==='431'?'':'opacity: 0.5;'"
                          data-track-text="继续支付" aria-label="继续支付" src="../../assets/H5/list-time.png" width="48" alt=""/>
                    </div>
                    <div  style="display:flex;align-items:center;justify-content:center;flex: 1">
                      <img
                          @click="(item.status==='已翻译' || item.status==='已下载' || item.status==='396' || item.status==='502')?readingFileH5(item.id):'javascript:void(0)'"
                          :style="(item.status==='已翻译' || item.status==='已下载' || item.status==='396' || item.status==='502')?'':'opacity: 0.5;'"
                          data-track-text="阅读文档" aria-label="阅读文档" src="../../assets/H5/list-read.png" width="54" alt=""/>
                    </div>
                    <div style="display:flex;align-items:center;justify-content:center;flex: 1">
                      <img
                          @click="item.status==='已翻译' || item.status==='已下载' || item.status==='已转换'||item.status === '396'||item.status === '502'?item.uploadType===1?downloadConvertFileH5(item):downloadFileH5(item):'javascript:void(0)'"
                          :style="item.status==='已翻译' || item.status==='已下载' || item.status==='已转换'||item.status === '396'||item.status === '502'?'':'opacity: 0.5;'"
                          data-track-text="下载文档" aria-label="下载文档" src="../../assets/H5/list-del.png" width="40" alt=""/>
                    </div>
                    <div style="display:flex;align-items:center;justify-content:center;flex: 1">
                      <img
                          @click="(item.status==='431')||item.status==='待支付' || item.status==='已翻译' || item.status==='已下载'||item.status === '已转换'||item.status === '394'||item.status === '396'||item.status === '502'?deleteFileH5(item.id):'javascript:void(0)'"
                          :style="(item.status==='431')||item.status==='待支付' || item.status==='已翻译' || item.status==='已下载'||item.status === '已转换'||item.status === '394'||item.status === '396'||item.status === '502'?'':'opacity: 0.5;'"
                          data-track-text="删除文档" aria-label="删除文档" src="../../assets/H5/liet-down.png" width="48" alt=""/>
                    </div>
                  </div>
                  <div slot="reference">
                    <div style="margin-top: 20px;" class="item">
                      <div
                          :class="item.status==='已翻译'||item.status==='已转换'||item.status==='396'?'item-status':'item-other'">
                        {{
                          item.status === '394' ? "待支付" :
                              item.status === '431' ? "等待客服沟通......" :
                                  item.status === '395' ? "等待译员处理" :
                                      item.status === '396' ? "人工翻译已完成" :
                                          item.status === '502' ? "已下载" :
                                              item.status === '501' ? "已删除" :
                                                  item.status === '500' ? "已过期" :
                                                      item.status === '448' ? "任务终止,退款中" : item.status
                        }}
                      </div>
                      <div class="item-name">{{ item.name }}</div>
                    </div>
                    <div class="item">
                      <div class="item-language">翻译语言：{{ item.language }}</div>
                      <div class="item-comment" style="flex: 2;text-overflow: ellipsis;white-space: nowrap">
                        翻译需求：{{ item.comment }}
                      </div>
                    </div>
                  </div>
                </el-popover>
              </li>
            </ul>
            <p v-if="loadingFour">加载中...</p>
            <p v-if="noMoreFour" style="font-size: 24px;font-family: Source Han Sans CN;font-weight: 400;color: #333333;">
              没有更多了</p>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import {translateServiceClient} from "@/tools/api/service";
import {
  deleteFileRequest,
  fileListRequest,
  FileListRequest, fileStatus,
  parentPowerRequest,
  payRequest,
  queryDocumentRequest,
  readDocumentRequest,
  readingFileRequest,
  statusRequest,
  submitConvertRequest,
  submitRequest,
} from "@/tools/api/translate-api";
import lanuages from "../../../language.json";

export default {
  name: "List",
  data() {
    return {
      allTableDataHas: false,
      tableDataHas: false,
      convertTableDataHas: false,
      polishTableDataHas: false,
      docTableDataHas: false,
      loading: false,
      loadingFirst: false,
      loadingSecond: false,
      loadingThree: false,
      loadingFour: false,
      isShowTransPro: false,
      isShowInRoaming: false,
      userId: '',
      isRoamingTimer: undefined,
      isRoamingTimerOut: undefined,
      qrcodeUrl: '',
      showRoaming: false,
      activeTabClassAll: '',
      activeTabClassFirst: '',
      activeTabClassSecond: '',
      activeTabClassThree: '',
      activeTabClassFour: '',
      groupUserInfos: [],
      userInfo: '',
      userType: '',
      iframeState: false,
      showloginOut: false,
      showHeader: true,
      groupUserInfo: '',
      title: '',
      activeName: 'first',
      isShowMoney: false,
      isShowFree: false,
      from: '',
      to: '',
      moneys: 0,
      orderMoney: 0,
      pages: 0,
      gridData: [],
      proGridData: [],
      proTableVisible: false,
      dialogTableVisible: false,
      customColorDownload: '#1b5ea4 !important',
      downloadMessage: '下载大型文档或转换文档时，需等待时间较长请您耐心等待！',
      downloadClass: 'downloadClass',
      downloadStatus: '',
      downloadPercentage: 0,
      isDownload: true,
      downloadTitle: '确定下载该文件的译文版本吗？',
      excelDialogVisibleConvert: false,
      deletevisible: false,
      customColor: '#4DBE92 !important',
      dialogVisible: false,
      currentPage: 1,
      pageSize: 10,
      count: 0,
      currentConvertPage: 1,
      pageConvertSize: 10,
      countConvert: 0,
      fileStatus: [
        {value: 0, label: "全部"},
        {value: 3, label: "已完成"},
        {value: 4, label: "已下载"}
      ],
      multipleSelection: [],
      tableData: [],
      transloading: false,
      convertloading: false,
      convertTableData: [],

      uploadType: 0,

      allTableData: [],
      allLoading: false,
      countAll: 0,
      currentAllPage: 1,
      pageAllSize: 10,

      docTableData: [],
      docLoading: false,
      countDoc: 0,
      currentDocPage: 1,
      pageDocSize: 10,

      polishTableData: [],
      polishLoading: false,
      countPolish: 0,
      currentPolishPage: 1,
      pagePolishSize: 10,

      statusList: '',
      fileName: "",
      content: "",
      radio: 'pdf',
      centerDialogVisible: false,
      centerDialogVisiblePro: false,
      excelDialogVisible: false,
      downloadDocLoad: false,
      timer: '',
      timerConvert: '',
      downloadTimer: '',
      downloadId: "",
      checkType: "all",
      fullscreenLoadings: undefined,
    }
  },
  created() {
    const req = this.getUrlParameterH5(this.$route.fullPath).response;
    if (req !== undefined && req !== null && req !== "") {
      this.checkPayH5(req);
    } else {
      this.activeName = 'all'
      this.activeTabClassAll = 'check-tab-active'
      this.initAllFileListH5()
    }
  },
  computed: {
    noMore() {
      return this.allTableDataHas
    },
    disabled() {
      return this.loading || this.noMore
    },
    noMoreFirst() {
      return this.tableDataHas
    },
    disabledFirst() {
      return this.loadingFirst || this.noMoreFirst
    },
    noMoreSecond() {
      return this.convertTableDataHas
    },
    disabledSecond() {
      return this.loadingSecond || this.noMoreSecond
    },
    noMoreThree() {
      return this.polishTableDataHas
    },
    disabledThree() {
      return this.loadingThree || this.noMoreThree
    },
    noMoreFour() {
      return this.docTableDataHas
    },
    disabledFour() {
      return this.loadingFour || this.noMoreFour
    },
  },
  mounted() {
    this.timer = setInterval(this.RandomNumBothH5, 5000);
    this.timerConvert = setInterval(this.RandomNumBothConvertH5, 5000);
  },
  watch: {
    fileName(val) {
      this.handleNameChangeH5()
    },
    statusList(val) {
      this.handleStatusChangeH5()
    },
    dialogTableVisible(val) {
      if (val) {
        let request = parentPowerRequest;
        request.setMoney(this.moneys)
        const TOKEN_KEY = "token";
        translateServiceClient.checkParentPower(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        }).then(res => {
          this.isShowMoney = res.getShowmoney();
          if (this.isShowMoney && this.moneys === 0) {
            this.isShowFree = true;
          }
        }).catch(err => {
          this.isShowMoney = true;
        })
      }
    }
  },
  methods: {
    loadFourH5() {
      this.handleDocCurrentChangeH5(this.currentDocPage + 1)
    },
    loadThreeH5() {
      this.handlePublishCurrentChangeH5(this.currentPolishPage + 1)
    },
    loadSecondH5() {
      this.handleConvertCurrentChangeH5(this.currentConvertPage + 1)
    },
    loadFirstH5() {
      this.handleCurrentChangeH5(this.currentPage + 1)
    },
    loadH5() {
      this.handleAllCurrentChangeH5(this.currentAllPage + 1)
    },
    clearTimeH5() {
      clearInterval(this.isRoamingTimer);
      clearTimeout(this.isRoamingTimerOut);
    },
    handleClickH5(name) {
      if (name === "all") {
        this.activeTabClassAll = 'check-tab-active'
        this.activeTabClassSecond = ''
        this.activeTabClassFirst = ''
        this.activeTabClassThree = ''
        this.activeTabClassFour = ''
        this.activeName = 'all'
        this.checkType = name
        this.fileStatus = [
          {value: 0, label: "全部"},
          {value: 3, label: "已完成"},
          {value: 4, label: "已下载"}
        ];
        if (this.allTableData.length === 0) {
          this.statusList = '';
          this.fileName = "";
          this.initAllFileListH5();
        }
      }
      if (name === "first") {
        this.activeTabClassAll = ''
        this.activeTabClassFirst = 'check-tab-active'
        this.activeTabClassSecond = ''
        this.activeTabClassThree = ''
        this.activeTabClassFour = ''
        this.activeName = 'first'
        this.checkType = name
        this.fileStatus = [
          {value: 0, label: "全部"},
          {value: 3, label: "已翻译"},
          {value: 4, label: "已下载"}
        ];
        if (this.tableData.length === 0) {
          this.statusList = '';
          this.fileName = "";
          this.initFileListH5();
        }
      }
      if (name === "second") {
        this.activeTabClassAll = ''
        this.activeTabClassFirst = ''
        this.activeTabClassSecond = 'check-tab-active'
        this.activeTabClassThree = ''
        this.activeTabClassFour = ''
        this.activeName = 'second'
        this.checkType = name
        this.fileStatus = [
          {value: 0, label: "全部"},
          {value: 3, label: "已转换"},
          {value: 4, label: "已下载"}
        ];
        if (this.convertTableData.length === 0) {
          this.statusList = '';
          this.fileName = "";
          this.initConvertFileListH5()
        }
      }
      if (name === "three") {
        this.activeTabClassAll = ''
        this.activeTabClassFirst = ''
        this.activeTabClassSecond = ''
        this.activeTabClassThree = 'check-tab-active'
        this.activeTabClassFour = ''
        this.activeName = 'three'
        this.checkType = name
        this.fileStatus = [
          {value: 0, label: "全部"},
          {value: 396, label: "已完成"},
          {value: 394, label: "待付款"},
          {value: 431, label: "等待客服确认"},
          {value: 448, label: "任务终止"},
          {value: 502, label: "已下载"}
        ];
        if (this.polishTableData.length === 0) {
          this.statusList = '';
          this.fileName = "";
          this.initPolishFileListH5()
        }
      }
      if (name === "four") {
        this.activeTabClassAll = ''
        this.activeTabClassFirst = ''
        this.activeTabClassSecond = ''
        this.activeTabClassThree = ''
        this.activeTabClassFour = 'check-tab-active'
        this.activeName = 'four'
        this.checkType = name
        this.fileStatus = [
          {value: 0, label: "全部"},
          {value: 396, label: "已完成"},
          {value: 394, label: "待付款"},
          {value: 431, label: "等待客服确认"},
          {value: 448, label: "任务终止"},
          {value: 502, label: "已下载"}
        ];
        if (this.docTableData.length === 0) {
          this.statusList = '';
          this.fileName = "";
          this.initDocFileListH5()
        }
      }

    },
    checkPayH5(req) {
      const request = payRequest;
      request.setResponse(req);
      const TOKEN_KEY = "token";
      translateServiceClient.checkPay(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (!res.getIspay()) {
          this.$message({
            center: true,
            type: 'error',
            showClose: true,
            duration: 3000,
            message: "支付失败！"
          });
        }
        this.activeName = 'all'
        this.initAllFileListH5();
      }).catch(err => {
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: "检查支付异常，请稍后！"
        });
      })
    },
    initPolishFileListH5() {
      const TOKEN_KEY = 'token';
      let request = new FileListRequest();
      request.setUploadtype(3)
      this.polishLoading = true
      translateServiceClient.fileList(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then((res) => {
        this.buildPolishDatalistH5(res)
        this.polishLoading = false
      }).catch(err => {
        this.polishLoading = false
        if (err && err.code === 5) {
          this.$router.push("/h5/login")
        }
      })
    },
    initDocFileListH5() {
      const TOKEN_KEY = 'token';
      let request = new FileListRequest();
      request.setUploadtype(2)
      this.docLoading = true
      translateServiceClient.fileList(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then((res) => {
        this.buildDocDatalistH5(res)
        this.docLoading = false
      }).catch(err => {
        this.docLoading = false
        if (err && err.code === 5) {
          this.$router.push("/h5/login")
        }
      })
    },
    initConvertFileListH5() {
      const TOKEN_KEY = 'token';
      let request = new FileListRequest();
      request.setUploadtype(1)
      this.convertloading = true
      translateServiceClient.fileList(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then((res) => {
        this.buildConvertDatalistH5(res)
        this.convertloading = false
      }).catch(err => {
        this.convertloading = false
        if (err && err.code === 5) {
          this.$router.push("/h5/login")
        }
      })
    },
    initAllFileListH5() {
      const TOKEN_KEY = 'token';
      let request = new FileListRequest();
      request.setUploadtype(4)
      this.transloading = true
      translateServiceClient.fileList(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then((res) => {
        this.buildAllDatalistH5(res)
        this.transloading = false
      }).catch(err => {
        this.transloading = false
        if (err && err.code === 5) {
          this.$router.push("/h5/login")
        }
      })
    },
    initFileListH5() {
      const TOKEN_KEY = 'token';
      let request = new FileListRequest();
      request.setUploadtype(0)
      this.transloading = true
      translateServiceClient.fileList(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then((res) => {
        this.buildDatalistH5(res)
        this.transloading = false
      }).catch(err => {
        this.transloading = false
        if (err && err.code === 5) {
          this.$router.push("/h5/login")
        }
      })
    },
    getUrlParameterH5(route) {
      //decodeURIComponent() 函数可对 encodeURIComponent() 函数编码的 URI 进行解码。
      let url = decodeURIComponent(route).split('?');
      url = url[url.length - 1];
      let obj = {};
      url.split('&&').map((query) => {
        let temp = query.split('=');
        obj[temp[0]] = temp[1];
      });
      return obj;
    },
    payH5(row) {
      this.gridData = [];
      this.to = row.language;
      const data = {};
      data.id = row.id;
      data.title = row.name;
      data.page = row.pageNum;
      let request = queryDocumentRequest;
      request.setId(row.id);
      if (this.checkType === "all") {
        this.allLoading = true
        request.setUploadType(row.uploadType)
        this.uploadType = row.uploadType;
      } else if (this.checkType === "first") {
        this.transloading = true
        request.setUploadType(0)
      } else if (this.checkType === "second") {
        this.convertloading = true
        request.setUploadType(1)
      } else if (this.checkType === "four") {
        this.docLoading = true
        request.setUploadType(2)
      } else if (this.checkType === "three") {
        this.polishLoading = true
        request.setUploadType(3)
      }
      const TOKEN_KEY = "token";
      translateServiceClient.queryDocument(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (res.getMessage()) {
          this.$message({
            center: true,
            type: 'error',
            showClose: true,
            duration: 3000,
            message: res.getMessage()
          });
          return;
        }
        if (this.checkType === "all") {
          if (row.uploadType === 0 || row.uploadType === 1) {
            data.page = res.getPage()
            data.money = res.getOrderMoney()
            this.moneys = res.getMoney()
            this.orderMoney = res.getOrderMoney()
            this.pages = res.getPage()
            this.dialogTableVisible = true;
            this.gridData.push(data)
          } else {
            data.money = res.getOrderMoney()
            this.moneys = res.getMoney()
            this.orderMoney = res.getOrderMoney()
            this.proTableVisible = true;
            this.proGridData.push(data)
          }
        } else if (this.checkType === "first" || this.checkType === "second") {
          data.page = res.getPage()
          data.money = res.getOrderMoney()
          this.moneys = res.getMoney()
          this.orderMoney = res.getOrderMoney()
          this.pages = res.getPage()
          this.dialogTableVisible = true;
          this.gridData.push(data)
        } else {
          data.money = res.getOrderMoney()
          this.moneys = res.getMoney()
          this.orderMoney = res.getOrderMoney()
          this.proTableVisible = true;
          this.proGridData.push(data)
        }
      }).catch(err => {
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: "支付异常请稍后"
        });
      })
    },
    submitConvertH5() {
      const ids = [];
      this.gridData.forEach((item, index) => {
        ids.push(item.id)
      })
      let request = submitConvertRequest;
      request.setIdsList(ids).setMoney(this.moneys);
      const TOKEN_KEY = "token";
      translateServiceClient.submitConvert(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (res.getStatus()) {
          if (res.getMessage() !== undefined && res.getMessage() !== null && res.getMessage() !== "") {
            window.open(res.getMessage(), "_self");
            return;
          }
          let innerrequest = fileListRequest
          if (this.checkType === "first") {
            this.transloading = true
            innerrequest.setUploadtype(0)
          } else if (this.checkType === "second") {
            this.convertloading = true
            innerrequest.setUploadtype(1)
          } else if (this.checkType === "all") {
            this.allLoading = true
            innerrequest.setUploadtype(4)
          }
          translateServiceClient.fileList(innerrequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }).then(res => {
            if (this.checkType === "first") {
              this.transloading = false
              this.buildDatalistH5(res)
            } else if (this.checkType === "second") {
              this.convertloading = false
              this.buildConvertDatalistH5(res)
            } else if (this.checkType === "all") {
              this.allLoading = false
              this.buildAllDatalistH5(res)
            }
          }).catch(err => {
            this.transloading = false
            this.convertloading = false
            if (err && err.code === 5) {
              this.$router.push("/h5/login")
            }
          })
          this.$message({
            center: true,
            type: 'success',
            showClose: true,
            duration: 3000,
            message: "支付成功"
          });
          this.dialogTableVisible = false;
          return
        }
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: res.getMessage()
        });
      }).catch(err => {
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: "提交失败请稍后再试"
        });
      })
    },
    submitProPayH5() {
      const ids = [];
      this.proGridData.forEach((item, index) => {
        ids.push(item.id)
      })
      let request = submitRequest;
      request.setIdsList(ids);
      request.setMoney(this.moneys);
      const TOKEN_KEY = "token";
      translateServiceClient.submitPro(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (res.getStatus()) {
          if (res.getMessage() !== undefined && res.getMessage() !== null && res.getMessage() !== "") {
            window.open(res.getMessage(), "_self");
            return;
          }
        }
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: res.getMessage()
        });
      }).catch(err => {
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: "提交失败请稍后再试"
        });
      })
    },
    submitPayH5() {
      if (this.checkType === "second" || (this.checkType === "all" && this.uploadType === 1)) {
        this.submitConvertH5()
        return
      }
      const ids = [];
      this.gridData.forEach((item, index) => {
        ids.push(item.id)
      })
      let request = submitRequest;
      request.setIdsList(ids);
      request.setMoney(this.moneys);
      const TOKEN_KEY = "token";
      translateServiceClient.submit(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (res.getStatus()) {
          if (res.getMessage() !== undefined && res.getMessage() !== null && res.getMessage() !== "") {
            window.open(res.getMessage(), "_self");
            return;
          }
          let innerrequest = new FileListRequest()
          if (this.checkType === "first") {
            this.transloading = true
            innerrequest.setUploadtype(0)
          } else if (this.checkType === "second") {
            this.convertloading = true
            innerrequest.setUploadtype(1)
          } else if (this.checkType === "all") {
            this.allLoading = true
            innerrequest.setUploadtype(4)
          }
          translateServiceClient.fileList(innerrequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }).then(res => {
            if (this.checkType === "first") {
              this.transloading = false
              this.buildDatalistH5(res)
            } else if (this.checkType === "second") {
              this.convertloading = false
              this.buildConvertDatalistH5(res)
            } else if (this.checkType === "all") {
              this.allLoading = false
              this.buildAllDatalistH5(res)
            }
          }).catch(err => {
            this.transloading = false
            this.convertloading = false
            if (err && err.code === 5) {
              this.$router.push("/h5/login")
            }
          })
          this.$message({
            center: true,
            type: 'success',
            showClose: true,
            duration: 3000,
            message: "支付成功"
          });
          this.dialogTableVisible = false;
          return
        }
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: res.getMessage()
        });
      }).catch(err => {
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: "提交失败请稍后再试"
        });
      })
    },
    indexConvertMethodH5(index) {
      return (this.currentConvertPage - 1) * this.pageConvertSize + index + 1;
    },
    indexMethodH5(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    },
    RandomNumBothH5() {
      this.tableData.forEach(item => {
        if (item.status === '排队中') {
          let request = statusRequest;
          request.setId(item.id);
          const TOKEN_KEY = 'token';
          translateServiceClient.checkStatus(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }).then(res => {
            const status = res.getStatus();
            if (status === 'Pending' || status === 'Pended' || status === 'Translating' || status === 'Translated' || status === 'Completing') {
              item.status = '翻译中'
              localStorage.setItem(item.id, 0);
            }
          }).catch(err => {
          })
          return;
        }
        if (item.status === '翻译中' || item.status === '处理中') {
          let request = statusRequest;
          request.setId(item.id);
          const TOKEN_KEY = 'token';
          translateServiceClient.checkStatus(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }).then(res => {
            let nums = localStorage.getItem(item.id);
            let Range = 5 - 1;
            let Rand = Math.random();
            //四舍五入
            let num = 1 + Math.round(Rand * Range) + parseInt(nums);
            if (num > 99) {
              item.numbers = 99;
              num = 99;
              item.status = '处理中';
            } else {
              item.numbers = num;
            }
            localStorage.setItem(item.id, num);
            if (res.getStatus() === 'Complete') {
              item.status = '已翻译';
              item.disables.disablesread = false;
              item.disables.disablesdown = false;
              item.disables.disablesdel = false;
            }
            if (res.getStatus() === 'TransError') {
              item.status = '翻译失败';
              item.disables.disablesread = true;
              item.disables.disablesdown = true;
              item.disables.disablesdel = false;
            }
            if (res.getStatus() === 'DocError') {
              item.status = '翻译失败';
              item.disables.disablesread = true;
              item.disables.disablesdown = true;
              item.disables.disablesdel = false;
            }
            if (item.name.endsWith("xls") || item.name.endsWith("xlsx")) {
              item.disables.disablesread = true;
            }
            if (item.name.endsWith("jpg")
                || item.name.endsWith("jpeg")
                || item.name.endsWith("png")
                || item.name.endsWith("tif")) {
              item.disables.disablesread = true;
            }
            if (document.getName().endsWith("ppt")
                || document.getName().endsWith("pptx")) {
              item.disables.disablesread = true;
            }
          }).catch(err => {
          })
        }
      })
    },
    RandomNumBothConvertH5() {
      this.convertTableData.forEach(item => {
        if (item.status === '排队中') {
          let request = statusRequest;
          request.setId(item.id);
          const TOKEN_KEY = 'token';
          translateServiceClient.checkStatus(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }).then(res => {
            const status = res.getStatus();
            if (status === 'Pending' || status === 'Pended' || status === 'Translating' || status === 'Translated' || status === 'Completing') {
              item.status = '转换中'
              localStorage.setItem(item.id, 0);
            }
          }).catch(err => {
          })
          return;
        }
        if (item.status === '转换中' || item.status === '处理中') {
          let request = statusRequest;
          request.setId(item.id);
          const TOKEN_KEY = 'token';
          translateServiceClient.checkStatus(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }).then(res => {
            let nums = localStorage.getItem(item.id);
            let Range = 5 - 1;
            let Rand = Math.random();
            //四舍五入
            let num = 1 + Math.round(Rand * Range) + parseInt(nums);
            if (num > 99) {
              item.numbers = 99;
              num = 99;
              item.status = '处理中';
            } else {
              item.numbers = num;
            }
            localStorage.setItem(item.id, num);
            if (res.getStatus() === 'Complete') {
              item.status = '已转换';
              item.disables.disablesread = false;
              item.disables.disablesdown = false;
              item.disables.disablesdel = false;
            }
            if (res.getStatus() === 'TransError' || res.getStatus() === '翻译失败') {
              item.status = '转换失败';
              item.disables.disablesread = true;
              item.disables.disablesdown = true;
              item.disables.disablesdel = false;
            }
            if (res.getStatus() === 'DocError' || res.getStatus() === '翻译失败') {
              item.status = '转换失败';
              item.disables.disablesread = true;
              item.disables.disablesdown = true;
              item.disables.disablesdel = false;
            }
          }).catch(err => {
          })
        }
      })
    },
    base64ToBlobH5(code, type) {
      let bstr = atob(code)
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {type: type});
    },
    toPathH5(id) {
      this.$router.push({
        name: "TransProStep",
        params: {documentId: id}
      });
    },
    readingFileH5(id) {
      let request = readDocumentRequest;
      const TOKEN_KEY = 'token';
      request.setId(id);
      translateServiceClient.checkReadDocument(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (res.getStatus()) {
          let routeData = this.$router.resolve({
            name: "DocView",
            params: {documentId: id}
          });
          window.open(routeData.href, '_blank')
          return;
        }
        this.$message({
          center: true,
          showClose: true,
          duration: 3000,
          message: res.getMessage()
        });
      }).catch(err => {
        if (err && err.code === 5) {
          this.$router.push("/h5/login")
          return;
        }
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: "请稍后再试！"
        });
      })
    },
    downloadConvertFileH5(row) {
      this.downloadTitle = '确定下载该文件的word版本吗？';
      this.downloadClass = 'downloadConvertClass';
      this.downloadStatus = '';
      this.downloadMessage = '下载大型文档或转换文档时，需等待时间较长请您耐心等待！';
      this.downloadPercentage = 0;
      this.isDownload = true;
      this.downloadDocLoad = false;
      this.downloadId = row.id;
      this.radio = "docx";
      this.excelDialogVisibleConvert = true;
    },
    downloadFileH5(row) {
      this.downloadTitle = '确定下载该文件的译文版本吗？';
      this.downloadClass = 'downloadClass';
      this.downloadStatus = '';
      this.downloadMessage = '下载大型文档或转换文档时，需等待时间较长请您耐心等待！';
      this.downloadPercentage = 0;
      this.isDownload = true;
      this.downloadDocLoad = false;
      this.downloadId = row.id;
      this.radio = row.name.substring(row.name.lastIndexOf(".") + 1);
      if (this.radio === "ppt" || this.radio === "pptx" || this.radio === "xls" || this.radio === "xlsx" || this.radio === "png" || this.radio === "jpg" || this.radio === "jpeg" || this.radio === "tif") {
        this.fullscreenLoadings = this.$loading({
          lock: true,
          text: '正在下载',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.downloadDocH5();
      } else {
        if (row.id.indexOf("-") > 0) {
          this.centerDialogVisible = true;
        } else {
          this.centerDialogVisiblePro = true;
        }
      }
    },
    downloadConvertDocH5() {
      let request = readingFileRequest;
      request.setId(this.downloadId);
      request.setType(this.radio)
      const that = this;
      const TOKEN_KEY = 'token';
      let stream = translateServiceClient.downLoadConvertFile(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      });
      this.isDownload = false;
      this.downloadDocLoad = true;
      this.downloadClass = 'downloadClass2';
      this.downloadTitle = '';
      let flag = 0;
      let content = "";
      let title = "";
      let type = "";
      let size = 0;
      let count = 0;
      this.downloadTimer = setInterval(() => {
        if (this.downloadPercentage < 98) {
          this.downloadPercentage += 1;
        }
        if (this.downloadPercentage === 100) {
          count += 1;
          if (count === 3) {
            clearInterval(this.downloadTimer);
            this.isDownload = true;
            this.downloadDocLoad = false;
            this.centerDialogVisible = false;
            this.centerDialogVisiblePro = false;
            this.excelDialogVisibleConvert = false;
            this.excelDialogVisible = false;
            this.customColorDownload = '#1b5ea4';
          }
        }
        if (this.downloadPercentage === 99) {
          this.customColorDownload = '#38cb1c';
          this.downloadMessage = '下载完成'
          this.downloadPercentage = 100;
        }
      }, 1000);
      stream.on('data', (res) => {
        if (res.getStatus() && flag === 0) {
          title = res.getTitle();
          type = res.getType();
          size = res.getSize();
        }
        if (!res.getStatus() && flag === 0) {
          that.$message({
            center: true,
            type: 'error',
            showClose: true,
            duration: 3000,
            message: res.getMessage()
          });
          clearInterval(this.downloadTimer);
          this.isDownload = true;
          this.downloadDocLoad = false;
          this.centerDialogVisible = false;
          this.centerDialogVisiblePro = false;
          this.excelDialogVisibleConvert = false;
          this.excelDialogVisible = false;
          return;
        }
        flag++;
        content += res.getContent_asB64();
      });
      stream.on('end', (end) => {
        let aLink = document.createElement('a');
        let blob = that.base64ToBlobH5(content, type);
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent("click", true, true);
        aLink.download = title;
        aLink.href = window.URL.createObjectURL(blob)
        aLink.click();
        that.downloadPercentage = 99;
      });
      stream.on('error', (err) => {
        clearInterval(this.downloadTimer);
        that.isDownload = true;
        that.downloadDocLoad = false;
        that.centerDialogVisible = false;
        this.centerDialogVisiblePro = false;
        that.excelDialogVisibleConvert = false;
        that.excelDialogVisible = false;
        if (err && err.code === 5) {
          this.$router.push("/h5/login")
          return;
        }
        if (err && err.code !== 0) {
          that.$message({
            center: true,
            type: 'error',
            showClose: true,
            duration: 3000,
            message: '下载文档失败，请稍后再试！'
          })
        }
      });
    },
    downloadDocH5() {
      let request = readingFileRequest;
      request.setId(this.downloadId);
      request.setType(this.radio)
      const that = this;
      const TOKEN_KEY = 'token';
      let stream = translateServiceClient.downLoadFile(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      });
      this.isDownload = false;
      this.downloadDocLoad = true;
      this.downloadClass = 'downloadClass2';
      this.downloadTitle = '';
      let flag = 0;
      let content = "";
      let title = "";
      let type = "";
      let size = 0;
      let count = 0;
      this.downloadTimer = setInterval(() => {
        if (this.downloadPercentage < 98) {
          this.downloadPercentage += 1;
        }
        if (this.downloadPercentage === 100) {
          count += 1;
          if (count === 3) {
            clearInterval(this.downloadTimer);
            this.isDownload = true;
            this.downloadDocLoad = false;
            this.centerDialogVisible = false;
            this.centerDialogVisiblePro = false;
            this.excelDialogVisible = false;
            this.excelDialogVisibleConvert = false;
            this.customColorDownload = '#1b5ea4';
          }
        }
        if (this.downloadPercentage === 99) {
          this.customColorDownload = '#38cb1c';
          this.downloadMessage = '下载完成'
          this.downloadPercentage = 100;
        }
      }, 1000);
      stream.on('data', (res) => {
        if (res.getStatus() && flag === 0) {
          title = res.getTitle();
          type = res.getType();
          size = res.getSize();
          if (title.indexOf(this.radio) === -1) {
            that.$message({
              center: true,
              type: 'warning',
              showClose: true,
              duration: 4000,
              message: "暂时不支持你选择的下载类型！已为您匹配到默认的下载类型，下载中请稍后！"
            });
          }
        }
        if (!res.getStatus() && flag === 0) {
          that.$message({
            center: true,
            type: 'error',
            showClose: true,
            duration: 3000,
            message: res.getMessage()
          });
          clearInterval(this.downloadTimer);
          this.isDownload = true;
          this.downloadDocLoad = false;
          this.centerDialogVisible = false;
          this.centerDialogVisiblePro = false;
          this.excelDialogVisible = false;
          this.excelDialogVisibleConvert = false;
          return;
        }
        flag++;
        content += res.getContent_asB64();
      });
      stream.on('end', (end) => {
        let aLink = document.createElement('a');
        let blob = that.base64ToBlobH5(content, type);
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent("click", true, true);
        aLink.download = title;
        aLink.href = window.URL.createObjectURL(blob)
        aLink.click();
        that.downloadPercentage = 99;
        if (that.fullscreenLoadings !== undefined) {
          that.fullscreenLoadings.close();
        }
      });
      stream.on('error', (err) => {
        clearInterval(this.downloadTimer);
        if (that.fullscreenLoadings !== undefined) {
          that.fullscreenLoadings.close();
        }
        that.isDownload = true;
        that.downloadDocLoad = false;
        that.centerDialogVisible = false;
        this.centerDialogVisiblePro = false;
        that.excelDialogVisibleConvert = false;
        that.excelDialogVisible = false;
        if (err && err.code === 5) {
          this.$router.push("/h5/login")
          return;
        }
        if (err && err.code !== 0) {
          that.$message({
            center: true,
            type: 'error',
            showClose: true,
            duration: 3000,
            message: '下载文档失败，请稍后再试！'
          })
        }
      });
    },
    deleteFileH5(id) {
      const that = this
      let request = deleteFileRequest;
      request.setId(id);
      const TOKEN_KEY = 'token';
      translateServiceClient.deleteFile(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (res.getStatus()) {
          this.$message({
            center: true,
            type: 'success',
            showClose: true,
            duration: 3000,
            message: '删除成功'
          })
          let innerrequest = new FileListRequest()
          if (this.checkType === "all") {
            that.allLoading = true
            innerrequest.setUploadtype(4)
          } else if (this.checkType === "first") {
            that.transloading = true
            innerrequest.setUploadtype(0)
          } else if (this.checkType === "second") {
            that.convertloading = true
            innerrequest.setUploadtype(1)
          } else if (this.checkType === "four") {
            that.docLoading = true
            innerrequest.setUploadtype(2)
          } else if (this.checkType === "three") {
            that.polishLoading = true
            innerrequest.setUploadtype(3)
          }
          translateServiceClient.fileList(innerrequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }).then(res => {
            if (this.checkType === "all") {
              that.allTableData = []
              that.allTableDataHas = false
              this.buildAllDatalistH5(res)
              this.allLoading = false
            } else if (this.checkType === "first") {
              that.tableData = []
              that.tableDataHas = false
              this.buildDatalistH5(res)
              this.transloading = false
            } else if (this.checkType === "second") {
              that.convertTableData = []
              that.convertTableDataHas = false
              this.buildConvertDatalistH5(res)
              this.convertloading = false
            } else if (this.checkType === "four") {
              that.docTableData = []
              that.docTableDataHas = false
              this.buildDocDatalistH5(res)
              this.docLoading = false
            } else if (this.checkType === "three") {
              that.polishTableData = []
              that.polishTableDataHas = false
              this.buildPolishDatalistH5(res)
              this.polishLoading = false
            }
          }).catch(err => {
            this.allLoading = false
            this.transloading = false
            this.convertloading = false
            this.docLoading = false
            this.polishLoading = false
            if (err && err.code === 5) {
              this.$router.push("/h5/login")
            }
          })
          return;
        }
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: '删除失败'
        })
      }).catch(err => {
        if (err && err.code === 5) {
          this.$router.push("/h5/login")
        }
      });
      scope._self.$refs[`popover-${scope.$index}`].doClose();
    },
    buildPolishDatalistH5(res) {
      let count = res.getCount();
      const documentsList = res.getDocumentsList()
      if (documentsList.length < 10) {
        this.polishTableDataHas = true
      }
      this.countPolish = count;
      documentsList.forEach((document, index) => {
        const to = document.getTo();
        const from = document.getFrom();
        const language = document.getTo();
        const pageNum = document.getPageNum() === '' ? '-' : document.getPageNum();
        const comment = document.getCommon() === '' ? '母语润色翻译' : document.getCommon();
        let status = document.getStatus();
        let disablesread = true;
        let disablesdown = true;
        let disablesdel = true;
        if (status === "396" || status === "502") {
          disablesread = false;
          disablesdown = false;
          disablesdel = false;
        }
        if (document.getName().endsWith("xls") || document.getName().endsWith("xlsx")) {
          disablesread = true;
        }
        if (document.getName().endsWith("jpg")
            || document.getName().endsWith("jpeg")
            || document.getName().endsWith("png")
            || document.getName().endsWith("tif")) {
          disablesread = true;
        }
        if (document.getName().endsWith("ppt")
            || document.getName().endsWith("pptx")) {
          disablesread = true;
        }
        if (status === "448") {
          disablesdel = false;
        }
        const data = {
          id: document.getId(),
          name: document.getName(),
          status: status,
          language: language,
          pageNum: pageNum,
          comment: comment,
          disables: {
            disablesread: disablesread,
            disablesdown: disablesdown,
            disablesdel: disablesdel,
          },
          datetime: document.getCreateTime(),
          refundMode: document.getRefundMode()
        };
        this.polishTableData.push(data);
      })
    },
    buildDocDatalistH5(res) {
      let count = res.getCount();
      const documentsList = res.getDocumentsList()
      if (documentsList.length < 10) {
        this.docTableDataHas = true
      }
      this.countDoc = count;
      documentsList.forEach((document, index) => {
        const to = document.getTo();
        const from = document.getFrom();
        const language = from + '-' + to;
        const pageNum = document.getPageNum() === '' ? '-' : document.getPageNum();
        const comment = document.getCommon() === '' ? '专业翻译' : document.getCommon();
        let status = document.getStatus();
        let disablesread = true;
        let disablesdown = true;
        let disablesdel = true;
        if (status === "396" || status === "502") {
          disablesread = false;
          disablesdown = false;
          disablesdel = false;
        }
        if (document.getName().endsWith("xls") || document.getName().endsWith("xlsx")) {
          disablesread = true;
        }
        if (document.getName().endsWith("jpg")
            || document.getName().endsWith("jpeg")
            || document.getName().endsWith("png")
            || document.getName().endsWith("tif")) {
          disablesread = true;
        }
        if (document.getName().endsWith("ppt")
            || document.getName().endsWith("pptx")) {
          disablesread = true;
        }
        if (status === "448") {
          disablesdel = false;
        }
        const data = {
          id: document.getId(),
          name: document.getName(),
          status: status,
          language: language,
          pageNum: pageNum,
          comment: comment,
          disables: {
            disablesread: disablesread,
            disablesdown: disablesdown,
            disablesdel: disablesdel,
          },
          datetime: document.getCreateTime(),
          refundMode: document.getRefundMode()
        };
        this.docTableData.push(data);
      })
    },
    buildConvertDatalistH5(res) {
      let count = res.getCount();
      const documentsList = res.getDocumentsList()
      if (documentsList.length < 10) {
        this.convertTableDataHas = true
      }
      this.countConvert = count;
      const that = this;
      documentsList.forEach((document, index) => {
        const language = 'pdf-word';
        const pageNum = document.getPageNum() === '' ? '-' : document.getPageNum();
        let status = document.getStatus();
        if (status === "已翻译") {
          status = '已转换'
        }
        let number = 0;
        if (index === 0) {
          if (status === '排队中' && that.statusList !== 1) {
            status = '转换中'
          }
        }
        if (localStorage.getItem(document.getId()) && status !== '已转换' && status !== '已下载' && status !== '翻译失败' && status !== '已过期' && status !== '已删除') {
          status = '转换中'
        }
        if (status === '转换中') {
          if (!localStorage.getItem(document.getId())) {
            localStorage.setItem(document.getId(), 0);
          }
          number = parseInt(localStorage.getItem(document.getId()));
          if (number > 99) {
            number = 99;
          }
        }
        let disablesread = true;
        let disablesdown = true;
        let disablesdel = true;
        if (status === "已转换" || status === "已下载") {
          disablesread = false;
          disablesdown = false;
          disablesdel = false;
        }
        if (document.getName().endsWith("xls") || document.getName().endsWith("xlsx")) {
          disablesread = true;
        }
        if (document.getName().endsWith("jpg")
            || document.getName().endsWith("jpeg")
            || document.getName().endsWith("png")
            || document.getName().endsWith("tif")) {
          disablesread = true;
        }
        if (document.getName().endsWith("ppt")
            || document.getName().endsWith("pptx")) {
          disablesread = true;
        }
        if (status === "翻译失败") {
          status = '转换失败'
          disablesdel = false;
        }
        const data = {
          id: document.getId(),
          name: document.getName(),
          status: status,
          language: language,
          pageNum: pageNum,
          disables: {
            disablesread: disablesread,
            disablesdown: disablesdown,
            disablesdel: disablesdel,
          },
          numbers: number,
          datetime: document.getCreateTime(),
          refundMode: document.getRefundMode()
        };
        this.convertTableData.push(data);
      })
    },
    buildAllDatalistH5(res) {
      let count = res.getCount();
      const documentsList = res.getDocumentsList()
      if (documentsList.length < 10) {
        this.allTableDataHas = true
      }
      this.countAll = count;
      const that = this;
      documentsList.forEach((document, index) => {
        const to = that.getChineseNameH5(document.getTo());
        const from = that.getChineseNameH5(document.getFrom());
        const language = document.getUploadType() === 1 ? "pdf-word" : from + '-' + to;
        const pageNum = document.getPageNum() === '' ? '-' : document.getPageNum();
        let status = document.getStatus();
        let number = 0;
        if (index === 0) {
          if (status === '排队中' && that.statusList !== 1) {
            status = '翻译中'
          }
        }
        if (localStorage.getItem(document.getId()) && status !== '已翻译' && status !== '已下载' && status !== '翻译失败' && status !== '已过期' && status !== '已删除') {
          status = '翻译中'
        }
        if (status === '翻译中') {
          if (!localStorage.getItem(document.getId())) {
            localStorage.setItem(document.getId(), 0);
          }
          number = parseInt(localStorage.getItem(document.getId()));
          if (number > 99) {
            number = 99;
          }
        }
        if (status === '已翻译' && document.getUploadType() === 1) {
          status = "已转换"
        }
        let disablesread = true;
        let disablesdown = true;
        let disablesdel = true;
        if (status === "已转换" || status === "已翻译" || status === "已下载" || status === "396" || status === "502") {
          disablesread = false;
          disablesdown = false;
          disablesdel = false;
        }
        if (document.getName().endsWith("xls") || document.getName().endsWith("xlsx")) {
          disablesread = true;
        }
        if (document.getName().endsWith("jpg")
            || document.getName().endsWith("jpeg")
            || document.getName().endsWith("png")
            || document.getName().endsWith("tif")) {
          disablesread = true;
        }
        if (document.getName().endsWith("ppt")
            || document.getName().endsWith("pptx")) {
          disablesread = true;
        }
        if (status === "翻译失败" || status === "448") {
          if (document.getUploadType() === 1) status = '转换失败'
          disablesdel = false;
        }
        const data = {
          id: document.getId(),
          name: document.getName(),
          status: status,
          language: language,
          pageNum: pageNum,
          disables: {
            disablesread: disablesread,
            disablesdown: disablesdown,
            disablesdel: disablesdel,
          },
          numbers: number,
          datetime: document.getCreateTime(),
          refundMode: document.getRefundMode(),
          comment: document.getUploadType() === 0 ? "机器翻译" : document.getUploadType() === 1 ? "转换文档" : document.getUploadType() === 2 ? "专业翻译" : "母语润色",
          uploadType: document.getUploadType()
        };
        this.allTableData.push(data);
      })
    },
    buildDatalistH5(res) {
      let count = res.getCount();
      const documentsList = res.getDocumentsList()
      if (documentsList.length < 10) {
        this.tableDataHas = true
      }
      this.count = count;
      const that = this;
      documentsList.forEach((document, index) => {
        const to = that.getChineseNameH5(document.getTo());
        const from = that.getChineseNameH5(document.getFrom());
        const language = from + '-' + to;
        const pageNum = document.getPageNum() === '' ? '-' : document.getPageNum();
        let status = document.getStatus();
        let number = 0;
        if (index === 0) {
          if (status === '排队中' && that.statusList !== 1) {
            status = '翻译中'
          }
        }
        if (localStorage.getItem(document.getId()) && status !== '已翻译' && status !== '已下载' && status !== '翻译失败' && status !== '已过期' && status !== '已删除') {
          status = '翻译中'
        }
        if (status === '翻译中') {
          if (!localStorage.getItem(document.getId())) {
            localStorage.setItem(document.getId(), 0);
          }
          number = parseInt(localStorage.getItem(document.getId()));
          if (number > 99) {
            number = 99;
          }
        }
        let disablesread = true;
        let disablesdown = true;
        let disablesdel = true;
        if (status === "已翻译" || status === "已下载") {
          disablesread = false;
          disablesdown = false;
          disablesdel = false;
        }
        if (document.getName().endsWith("xls") || document.getName().endsWith("xlsx")) {
          disablesread = true;
        }
        if (document.getName().endsWith("jpg")
            || document.getName().endsWith("jpeg")
            || document.getName().endsWith("png")
            || document.getName().endsWith("tif")) {
          disablesread = true;
        }
        if (document.getName().endsWith("ppt")
            || document.getName().endsWith("pptx")) {
          disablesread = true;
        }
        if (status === "翻译失败") {
          disablesdel = false;
        }
        const data = {
          id: document.getId(),
          name: document.getName(),
          status: status,
          language: language,
          pageNum: pageNum,
          disables: {
            disablesread: disablesread,
            disablesdown: disablesdown,
            disablesdel: disablesdel,
          },
          numbers: number,
          datetime: document.getCreateTime(),
          refundMode: document.getRefundMode()
        };
        this.tableData.push(data);
      })
    },
    getChineseNameH5(lanuage) {
      let label = lanuage;
      lanuages.forEach((item) => {
        if (item.value === lanuage) {
          label = item.label;
        }
      })
      return label;
    },
    handleNameChangeH5() {
      let that = this
      let request = new FileListRequest();
      if (this.checkType === "all") {
        this.allLoading = true
        request.setUploadtype(4)
      } else if (this.checkType === "first") {
        this.transloading = true
        request.setUploadtype(0)
      } else if (this.checkType === "second") {
        this.convertloading = true
        request.setUploadtype(1)
      } else if (this.checkType === "four") {
        this.docLoading = true
        request.setUploadtype(2)
      } else if (this.checkType === "three") {
        this.polishLoading = true
        request.setUploadtype(3)
      }
      request.setFileName(this.fileName)
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW)
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS)
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE)
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD)
      }
      if (this.statusList === 500) {
        fileStatusList.push(fileStatus.EXPIRE)
      }
      if (this.statusList === 501) {
        fileStatusList.push(fileStatus.DELETED)
      }
      if (this.statusList === 394) {
        fileStatusList.push(fileStatus.PEND_PAY)
      }
      if (this.statusList === 395) {
        fileStatusList.push(fileStatus.PEND_SUBMIT)
      }
      if (this.statusList === 396) {
        fileStatusList.push(fileStatus.SUCCESS)
      }
      if (this.statusList === 431) {
        fileStatusList.push(fileStatus.CUSTOM_SUBMIT)
      }
      if (this.statusList === 432) {
        fileStatusList.push(fileStatus.CUSTOM_PROCESS)
      }
      if (this.statusList === 448) {
        fileStatusList.push(fileStatus.OVER)
      }
      if (this.statusList === 449) {
        fileStatusList.push(fileStatus.CUSTOM_OVER)
      }
      if (this.statusList === 502) {
        fileStatusList.push(fileStatus.DOWN)
      }
      request.setFileStatusList(fileStatusList)
      const TOKEN_KEY = 'token';
      translateServiceClient.fileList(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (that.checkType === "all") {
          that.allTableDataHas = false
          that.allTableData = []
          that.buildAllDatalistH5(res)
          that.allLoading = false
        } else if (that.checkType === "first") {
          that.tableData = []
          that.tableDataHas = false
          that.buildDatalistH5(res)
          that.transloading = false
        } else if (that.checkType === "second") {
          that.convertTableData = []
          that.convertTableDataHas = false
          that.buildConvertDatalistH5(res)
          that.convertloading = false
        } else if (that.checkType === "four") {
          that.docTableData = []
          that.docTableDataHas = false
          that.buildDocDatalistH5(res)
          that.docLoading = false
        } else if (that.checkType === "three") {
          that.polishTableData = []
          that.polishTableDataHas = false
          that.buildPolishDatalistH5(res)
          that.polishLoading = false
        }
      }).catch(err => {
        this.transloading = false
        this.convertloading = false
        this.docLoading = false
        this.polishLoading = false
        this.allLoading = false
        if (err && err.code === 5) {
          this.$router.push("/h5/login")
        }
      })
    },
    handleStatusChangeH5() {
      let that = this
      let request = new FileListRequest()
      if (this.checkType === "all") {
        this.allLoading = true
        request.setUploadtype(4)
      } else if (this.checkType === "first") {
        this.transloading = true
        request.setUploadtype(0)
      } else if (this.checkType === "second") {
        this.convertloading = true
        request.setUploadtype(1)
      } else if (this.checkType === "four") {
        this.docLoading = true
        request.setUploadtype(2)
      } else if (this.checkType === "three") {
        this.polishLoading = true
        request.setUploadtype(3)
      }
      if (this.statusList === 0) {
        request.setFileStatusList([])
        const TOKEN_KEY = 'token';
        translateServiceClient.fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
        }).then(res => {
          if (that.checkType === "all") {
            that.allTableDataHas = false
            that.allTableData = []
            that.buildAllDatalistH5(res)
            that.allLoading = false
          } else if (that.checkType === "first") {
            that.tableData = []
            that.tableDataHas = false
            that.buildDatalistH5(res)
            that.transloading = false
          } else if (that.checkType === "second") {
            that.convertTableData = []
            that.convertTableDataHas = false
            that.buildConvertDatalistH5(res)
            that.convertloading = false
          } else if (that.checkType === "four") {
            that.docTableData = []
            that.docTableDataHas = false
            that.buildDocDatalistH5(res)
            that.docLoading = false
          } else if (that.checkType === "three") {
            that.polishTableData = []
            that.polishTableDataHas = false
            that.buildPolishDatalistH5(res)
            that.polishLoading = false
          }
        }).catch(err => {
          this.allLoading = false
          this.transloading = false
          this.convertloading = false
          this.docLoading = false
          this.polishLoading = false
          if (err && err.code === 5) {
            this.$router.push("/h5/login")
          }
        })
        return;
      }
      request.setFileName(this.fileName)
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW)
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS)
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE)
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD)
      }
      if (this.statusList === 500) {
        fileStatusList.push(fileStatus.EXPIRE)
      }
      if (this.statusList === 501) {
        fileStatusList.push(fileStatus.DELETED)
      }
      if (this.statusList === 394) {
        fileStatusList.push(fileStatus.PEND_PAY)
      }
      if (this.statusList === 395) {
        fileStatusList.push(fileStatus.PEND_SUBMIT)
      }
      if (this.statusList === 396) {
        fileStatusList.push(fileStatus.SUCCESS)
      }
      if (this.statusList === 431) {
        fileStatusList.push(fileStatus.CUSTOM_SUBMIT)
      }
      if (this.statusList === 432) {
        fileStatusList.push(fileStatus.CUSTOM_PROCESS)
      }
      if (this.statusList === 448) {
        fileStatusList.push(fileStatus.OVER)
      }
      if (this.statusList === 449) {
        fileStatusList.push(fileStatus.CUSTOM_OVER)
      }
      if (this.statusList === 502) {
        fileStatusList.push(fileStatus.DOWN)
      }
      request.setFileStatusList(fileStatusList)
      const TOKEN_KEY = 'token';
      translateServiceClient.fileList(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (that.checkType === "all") {
          that.allTableDataHas = false
          that.allTableData = []
          that.buildAllDatalistH5(res)
          that.allLoading = false
        } else if (that.checkType === "first") {
          that.tableData = []
          that.tableDataHas = false
          that.buildDatalistH5(res)
          that.transloading = false
        } else if (that.checkType === "second") {
          that.convertTableData = []
          that.convertTableDataHas = false
          that.buildConvertDatalistH5(res)
          that.convertloading = false
        } else if (that.checkType === "four") {
          that.docTableData = []
          that.docTableDataHas = false
          that.buildDocDatalistH5(res)
          that.docLoading = false
        } else if (that.checkType === "three") {
          that.polishTableData = []
          that.polishTableDataHas = false
          that.buildPolishDatalistH5(res)
          that.polishLoading = false
        }
      }).catch(err => {
        this.transloading = false
        this.convertloading = false
        this.docLoading = false
        this.polishLoading = false
        this.allLoading = false
        if (err && err.code === 5) {
          this.$router.push("/h5/login")
        }
      })
    },
    handleAllSizeChangeH5(val) {
      this.pageAllSize = val;
      let request = new FileListRequest();
      this.allLoading = true
      request.setPagesize(this.pageAllSize)
      request.setFileName(this.fileName)
      request.setUploadtype(4)
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW)
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS)
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE)
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD)
      }
      request.setFileStatusList(fileStatusList)
      const TOKEN_KEY = 'token';
      translateServiceClient.fileList(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        this.buildAllDatalistH5(res)
        this.allLoading = false
      }).catch(err => {
        this.allLoading = false
        if (err && err.code === 5) {
          this.$router.push("/h5/login")
        }
      })
    },
    handlePublishSizeChangeH5(val) {
      this.pagePolishSize = val;
      let request = new FileListRequest();
      this.polishLoading = true
      request.setPagesize(this.pagePolishSize)
      request.setFileName(this.fileName)
      request.setUploadtype(3)
      let fileStatusList = [];
      if (this.statusList === 500) {
        fileStatusList.push(fileStatus.EXPIRE)
      }
      if (this.statusList === 501) {
        fileStatusList.push(fileStatus.DELETED)
      }
      if (this.statusList === 394) {
        fileStatusList.push(fileStatus.PEND_PAY)
      }
      if (this.statusList === 395) {
        fileStatusList.push(fileStatus.PEND_SUBMIT)
      }
      if (this.statusList === 396) {
        fileStatusList.push(fileStatus.SUCCESS)
      }
      if (this.statusList === 431) {
        fileStatusList.push(fileStatus.CUSTOM_SUBMIT)
      }
      if (this.statusList === 432) {
        fileStatusList.push(fileStatus.CUSTOM_PROCESS)
      }
      if (this.statusList === 448) {
        fileStatusList.push(fileStatus.OVER)
      }
      if (this.statusList === 449) {
        fileStatusList.push(fileStatus.CUSTOM_OVER)
      }
      if (this.statusList === 502) {
        fileStatusList.push(fileStatus.DOWN)
      }
      request.setFileStatusList(fileStatusList)
      const TOKEN_KEY = 'token';
      translateServiceClient.fileList(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        this.buildPolishDatalistH5(res)
        this.polishLoading = false
      }).catch(err => {
        this.polishLoading = false
        if (err && err.code === 5) {
          this.$router.push("/h5/login")
        }
      })
    },
    handleDocSizeChangeH5(val) {
      this.pageDocSize = val;
      let request = new FileListRequest();
      this.docLoading = true
      request.setPagesize(this.pageDocSize)
      request.setFileName(this.fileName)
      request.setUploadtype(2)
      let fileStatusList = [];
      if (this.statusList === 500) {
        fileStatusList.push(fileStatus.EXPIRE)
      }
      if (this.statusList === 501) {
        fileStatusList.push(fileStatus.DELETED)
      }
      if (this.statusList === 394) {
        fileStatusList.push(fileStatus.PEND_PAY)
      }
      if (this.statusList === 395) {
        fileStatusList.push(fileStatus.PEND_SUBMIT)
      }
      if (this.statusList === 396) {
        fileStatusList.push(fileStatus.SUCCESS)
      }
      if (this.statusList === 431) {
        fileStatusList.push(fileStatus.CUSTOM_SUBMIT)
      }
      if (this.statusList === 432) {
        fileStatusList.push(fileStatus.CUSTOM_PROCESS)
      }
      if (this.statusList === 448) {
        fileStatusList.push(fileStatus.OVER)
      }
      if (this.statusList === 449) {
        fileStatusList.push(fileStatus.CUSTOM_OVER)
      }
      if (this.statusList === 502) {
        fileStatusList.push(fileStatus.DOWN)
      }
      request.setFileStatusList(fileStatusList)
      const TOKEN_KEY = 'token';
      translateServiceClient.fileList(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        this.buildDocDatalistH5(res)
        this.docLoading = false
      }).catch(err => {
        this.docLoading = false
        if (err && err.code === 5) {
          this.$router.push("/h5/login")
        }
      })
    },
    handleConvertSizeChangeH5(val) {
      this.pageConvertSize = val;
      let request = new FileListRequest();
      this.convertloading = true
      request.setPagesize(this.pageConvertSize)
      request.setFileName(this.fileName)
      request.setUploadtype(1)
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW)
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS)
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE)
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD)
      }
      request.setFileStatusList(fileStatusList)
      const TOKEN_KEY = 'token';
      translateServiceClient.fileList(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        this.buildConvertDatalistH5(res)
        this.convertloading = false
      }).catch(err => {
        this.convertloading = false
        if (err && err.code === 5) {
          this.$router.push("/h5/login")
        }
      })
    },
    handleSizeChangeH5(val) {
      this.pageSize = val;
      let request = new FileListRequest();
      this.transloading = true
      request.setPagesize(this.pageSize)
      request.setFileName(this.fileName)
      request.setUploadtype(0)
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW)
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS)
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE)
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD)
      }
      request.setFileStatusList(fileStatusList)
      const TOKEN_KEY = 'token';
      translateServiceClient.fileList(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        this.buildDatalistH5(res)
        this.transloading = false
      }).catch(err => {
        this.transloading = false
        if (err && err.code === 5) {
          this.$router.push("/h5/login")
        }
      })
    },
    handlePublishCurrentChangeH5(val) {
      this.currentPolishPage = val
      let request = new FileListRequest();
      request.setPagesize(this.pagePolishSize)
      request.setCurrentpage(this.currentPolishPage)
      request.setFileName(this.fileName)
      this.polishLoading = true
      request.setUploadtype(3)
      let fileStatusList = [];
      if (this.statusList === 500) {
        fileStatusList.push(fileStatus.EXPIRE)
      }
      if (this.statusList === 501) {
        fileStatusList.push(fileStatus.DELETED)
      }
      if (this.statusList === 394) {
        fileStatusList.push(fileStatus.PEND_PAY)
      }
      if (this.statusList === 395) {
        fileStatusList.push(fileStatus.PEND_SUBMIT)
      }
      if (this.statusList === 396) {
        fileStatusList.push(fileStatus.SUCCESS)
      }
      if (this.statusList === 431) {
        fileStatusList.push(fileStatus.CUSTOM_SUBMIT)
      }
      if (this.statusList === 432) {
        fileStatusList.push(fileStatus.CUSTOM_PROCESS)
      }
      if (this.statusList === 448) {
        fileStatusList.push(fileStatus.OVER)
      }
      if (this.statusList === 449) {
        fileStatusList.push(fileStatus.CUSTOM_OVER)
      }
      if (this.statusList === 502) {
        fileStatusList.push(fileStatus.DOWN)
      }
      request.setFileStatusList(fileStatusList)
      const TOKEN_KEY = 'token';
      translateServiceClient.fileList(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        this.buildPolishDatalistH5(res)
        this.polishLoading = false
      }).catch(err => {
        this.polishLoading = false
        if (err && err.code === 5) {
          this.$router.push("/h5/login")
        }
      })
    },
    handleDocCurrentChangeH5(val) {
      this.currentDocPage = val
      let request = new FileListRequest();
      request.setPagesize(this.pageDocSize)
      request.setCurrentpage(this.currentDocPage)
      request.setFileName(this.fileName)
      this.docLoading = true
      request.setUploadtype(2)
      let fileStatusList = [];
      if (this.statusList === 500) {
        fileStatusList.push(fileStatus.EXPIRE)
      }
      if (this.statusList === 501) {
        fileStatusList.push(fileStatus.DELETED)
      }
      if (this.statusList === 394) {
        fileStatusList.push(fileStatus.PEND_PAY)
      }
      if (this.statusList === 395) {
        fileStatusList.push(fileStatus.PEND_SUBMIT)
      }
      if (this.statusList === 396) {
        fileStatusList.push(fileStatus.SUCCESS)
      }
      if (this.statusList === 431) {
        fileStatusList.push(fileStatus.CUSTOM_SUBMIT)
      }
      if (this.statusList === 432) {
        fileStatusList.push(fileStatus.CUSTOM_PROCESS)
      }
      if (this.statusList === 448) {
        fileStatusList.push(fileStatus.OVER)
      }
      if (this.statusList === 449) {
        fileStatusList.push(fileStatus.CUSTOM_OVER)
      }
      if (this.statusList === 502) {
        fileStatusList.push(fileStatus.DOWN)
      }
      request.setFileStatusList(fileStatusList)
      const TOKEN_KEY = 'token';
      translateServiceClient.fileList(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        this.buildDocDatalistH5(res)
        this.docLoading = false
      }).catch(err => {
        this.docLoading = false
        if (err && err.code === 5) {
          this.$router.push("/h5/login")
        }
      })
    },
    handleConvertCurrentChangeH5(val) {
      this.currentConvertPage = val
      let request = new FileListRequest();
      request.setPagesize(this.pageConvertSize)
      request.setCurrentpage(this.currentConvertPage)
      request.setFileName(this.fileName)
      this.convertloading = true
      request.setUploadtype(1)
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW)
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS)
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE)
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD)
      }
      request.setFileStatusList(fileStatusList)
      const TOKEN_KEY = 'token';
      translateServiceClient.fileList(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        this.buildConvertDatalistH5(res)
        this.convertloading = false
      }).catch(err => {
        this.convertloading = false
        if (err && err.code === 5) {
          this.$router.push("/h5/login")
        }
      })
    },
    handleCurrentChangeH5(val) {
      this.currentPage = val
      let request = new FileListRequest();
      this.transloading = true
      request.setPagesize(this.pageSize)
      request.setCurrentpage(this.currentPage)
      request.setFileName(this.fileName)
      request.setUploadtype(0)
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW)
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS)
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE)
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD)
      }
      request.setFileStatusList(fileStatusList)
      const TOKEN_KEY = 'token';
      translateServiceClient.fileList(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        this.buildDatalistH5(res)
        this.transloading = false
      }).catch(err => {
        this.transloading = false
        if (err && err.code === 5) {
          this.$router.push("/h5/login")
        }
      })
    },
    handleAllCurrentChangeH5(val) {
      this.currentAllPage = val
      let request = new FileListRequest();
      this.allLoading = true
      request.setPagesize(this.pageAllSize)
      request.setCurrentpage(this.currentAllPage)
      request.setFileName(this.fileName)
      request.setUploadtype(4)
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW)
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS)
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE)
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD)
      }
      request.setFileStatusList(fileStatusList)
      const TOKEN_KEY = 'token';
      translateServiceClient.fileList(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        this.buildAllDatalistH5(res)
        this.allLoading = false
      }).catch(err => {
        this.allLoading = false
        if (err && err.code === 5) {
          this.$router.push("/h5/login")
        }
      })
    },
    handleSelectionChangeH5(val) {
      this.multipleSelection = val;
    },
    tableRowClassNameH5({row, rowIndex}) {
      if (rowIndex % 2 !== 0) {
        return 'rows-oushu';
      }
      return 'rows';
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.downloadTimer);
    clearInterval(this.timerConvert);
  }
}
</script>
<style lang="less">
.el-popover.popper-class {
  background: #95060600;
  padding: 0;
  border: 0px solid #EBEEF5;
  box-shadow: 0 0px 0px 0 rgba(0, 0, 0, .1);
}
</style>
<style lang="less" scoped>
.fileStatus {
  .el-select-dropdown__item.selected {
    color: #063F95;
    font-weight: 400;
    font-size: 24px !important;
    font-family: Source Han Sans CN;
    font-weight: 400;
  }

  .el-select-dropdown__item {
    font-weight: 400;
    font-size: 24px !important;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
  }
}

.list-main {
  min-width: 765px;
  width: 100%;
  background: #f5f5f5;
  display: flex;
  flex-flow: column;
  align-items: center;
  border-bottom: 1px solid #DDDDDD;

  .trans-header {
    width: 100%;
    height: 80px;
    background: #FFFFFF;
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    justify-content: center;

    .trans-header-select {
      width: 765px;
      display: flex;
      align-items: center;
      justify-content: flex-start;

      .check-tab-default {
        flex: 1;
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 72px;
        height: 74px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .check-tab-active {
        border-bottom: 4px solid #063F95;
      }

    }

  }

  .trans-list-context {
    width: 100%;
    background: #f5f5f5;
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    justify-content: center;

    .list-context {
      width: 768px;
      display: flex;
      align-items: center;
      justify-content: center;

      .list-context-search {
        display: flex;
        margin-top: 5px;
        margin-bottom: 20px;

        /deep/ .list-context-search-input {
          margin-right: 22px;

          .el-input {
            width: 420px;
            height: 60px;
            background: #FFFFFF;
            border-radius: 3px;

            .el-input__icon {
              height: 100%;
              width: 25px;
              text-align: center;
              transition: all .3s;
              line-height: 40px;
              font-size: 24px;
            }

            .el-input__inner {
              width: 420px;
              height: 60px;
              background: #FFFFFF;
              font-size: 24px;
              font-family: Microsoft YaHei;
              font-weight: 400;
            }
          }
        }

        /deep/ .list-context-search-select {
          .el-input {
            width: 263px;
            height: 60px;
            background: #FFFFFF;
            border-radius: 3px;

            .el-select .el-input .el-select__caret {
              color: #C0C4CC;
              transition: transform .3s;
              transform: rotateZ(180deg);
              cursor: pointer;
              font-size: 24px;
            }

            .el-input__inner {
              width: 263px;
              height: 60px;
              background: #FFFFFF;
              font-size: 24px;
              font-family: Microsoft YaHei;
              font-weight: 400;
            }
          }
        }
      }

      .infinite-list {
        height: 965px;
        padding: 0;
        margin: 0;
        list-style: none;

        .infinite-list-item {
          width: 706px;
          height: 120px;
          background: #FFFFFF;
          margin-bottom: 12px;
          display: flex;
          flex-flow: column;

          .item {
            display: flex;
            align-items: center;
            margin-left: 24px;

            .item-status {
              height: 30px;
              background: #4DBE92;
              border-radius: 5px;
              font-size: 24px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #FFFFFF;
              display: flex;
              align-items: center;
              justify-content: center;
              text-align: center;
              line-height: 0px;
              margin-right: 9px;
            }

            .item-other {
              padding: 0px 10px;
              height: 30px;
              background: #999999;
              border-radius: 5px;
              font-size: 24px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #FFFFFF;
              display: flex;
              align-items: center;
              justify-content: center;
              text-align: center;
              line-height: 0px;
              margin-right: 9px;
            }

            .item-name {
              width: 474px;
              height: 30px;
              font-size: 24px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #333333;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .item-language {
              height: 23px;
              font-size: 24px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #999999;
              line-height: 72px;
              flex: 1.5;
            }

            .item-comment {
              height: 23px;
              font-size: 24px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #999999;
              line-height: 72px;
              flex: 1;
            }

            .item-pageNum {
              height: 23px;
              font-size: 24px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #999999;
              line-height: 72px;
              flex: 0.5;
            }
          }
        }
      }
    }
  }
}


</style>
